module.exports = __webpack_public_path__ + "img/bookmark-dash-fill.803bbe7e.svg";